<template>
    <div class="logins">
        <div class="logins_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
        </div>
        <div class="logins_bottom">
            <p class="text">手机号登录</p>
            <p class="prompt">未注册手机号将自动注册</p>
        </div>
        <van-form class="login_form">
            <van-field
                class="input_tel"
                v-model="phone"
                type="tel"
                clearable
                placeholder="请输入手机号"
                :rules="[{ required: true }]"
            >
            </van-field>
            <van-field name="checkbox" class="input_check">
                <template #input>
                    <van-checkbox v-model="agree" shape="square">
                        <template #icon="props">
                            <img
                                class="img-icon"
                                :src="
                                    props.checked
                                        ? require('@/assets/img/login/l_sel.png')
                                        : require('@/assets/img/login/l_unsel.png')
                                "
                            />
                        </template>
                        我已阅读并同意《<span
                            style="color: #4266f5"
                            @click="$router.push('/apptcp')"
                            >使用协议</span
                        >》《<span style="color: #4266f5" @click="$router.push('/mPAgreement')"
                            >隐私政策</span
                        >》</van-checkbox
                    >
                </template>
            </van-field>
            <div class="but">
                <van-button
                    round
                    block
                    type="info"
                    class="form_btn"
                    @click="getCode"
                    :disabled="codeFlag"
                    >获取验证码</van-button
                >
            </div>
            <div class="password" @click="toPasswordLogin">密码登录</div>
            <div id="weChat-container"></div>
        </van-form>
        <VerifyCode
            ref="verifyCode"
            :boxShow="verifyShow"
            :phone="phone"
            @success="handleVerifySuccess"
            @close="() => (verifyShow = false)"
        />
        <TipsDialog
            :showDialog="showDialog"
            @dialogCancel="showDialog = false"
            @dialogConfirm="dialogConfirm"
        >
            <p>
                我已阅读并同意《<span style="color: #4266f5" @click="$router.push('/apptcp')"
                    >使用协议</span
                >》《<span style="color: #4266f5" @click="$router.push('/mPAgreement')"
                    >隐私政策</span
                >》
            </p>
        </TipsDialog>
    </div>
</template>

<script>
import VerifyCode from "./VerifyCode.vue";
import TipsDialog from "@/views/mobileView/components/tipsDialog.vue";
import { Toast, Dialog } from "vant";
export default {
    name: "logins",
    components: {
        TipsDialog,
        VerifyCode,
    },
    data() {
        return {
            phone: "",
            agree: false,
            showDialog: false,
            pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            verifyWidth: 400,
            isVerify: false,
            verifyShow: false,
        };
    },
    /* 计算属性 */
    computed: {
        /* 函数名称不能与data和methods内的名称一致 */
        codeFlag() {
            const { pattern, phone } = this;
            var reg = new RegExp(pattern);
            return !reg.test(phone);
            /* 必须return一个结果，当前结果随着内部使用的data数据的变化而动态变化 */
        },
    },
    methods: {
        to() {
            window.history.go(-1);
        },
        async handleVerifySuccess() {
            this.isVerify = true;
            this.verifyShow = false;
            const res = await this.$apis.loginServe.getCode({
                phone: this.phone,
                adapter: "login",
            });
            if (res.resultCode == "200") {
                Toast("获取成功");
                this.$router.push({
                    path: "/getcode",
                    query: { phone: this.phone },
                });
            } else {
                this.isVerify = false;
                Toast(res.resultDesc);
            }
        },
        // 获取验证码
        async getCode() {
            if (this.agree) {
                if (!this.isVerify) this.verifyShow = true;
                this.showDialog = false;
            } else {
                this.showDialog = true;
            }
        },
        // 账号密码登录
        toPasswordLogin() {
            this.$router.replace("Password");
        },
        dialogConfirm() {
            this.agree = true;
            this.getCode();
        },
    },
};
</script>

<style lang="scss" scoped>
html,
body {
    background: #fff;
}

.logins {
    width: 100%;
    height: 100%;
    background: #fff;

    .logins_top {
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
        line-height: 44px;
    }

    .logins_bottom {
        width: 84%;
        margin: 0 auto;
        overflow: hidden;

        .text {
            font-size: 23px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin-top: 42px;
        }

        .prompt {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            margin-top: 9px;
        }
    }

    .login_form {
        width: 92%;
        margin: 16px auto;

        .input_check {
            background-color: unset;

            &::after {
                content: none !important;
            }

            .img-icon {
                width: 13px;
                height: 13px;
            }
        }

        .but {
            width: 92%;
            // margin-top: 24px;
            margin: 24px auto;

            .form_btn {
                height: 40px;
                background: #4a79f1;
                border-radius: 22px;

                .van-button__text {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                }
            }
        }

        .password {
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
        }
    }
}
</style>
